module.exports = __webpack_public_path__ + "img/iconyl.5639886d.png";